import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CetateanAccountsService } from '../cetatean-accounts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ICitizenInfo } from '../cetatean-accounts.interface';

@Component({
    selector: 'app-info-cetatean',
    templateUrl: './info-cetatean.component.html',
    styleUrls: ['./info-cetatean.component.scss']
})
export class InfoCetateanComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;
    citizen!: ICitizenInfo;

    token!: string;
    isLoading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: ICitizenInfo,
        private dialogRef: MatDialogRef<InfoCetateanComponent>,
        private cetateanAccountsService: CetateanAccountsService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
        this.citizen = this.data;
    }
    ngOnInit(): void {
        this.getClientDetails(this.data.id_cetatean);
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.cetateanAccountsService.setToken(token);
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    getClientDetails(citizenId: number) {
        this.cetateanAccountsService.getCitizenById(citizenId);
    }
}
